<template>
    <!--Site Footer Start-->
    <footer class="site-footer">
        <div class="site-footer-bg" style="background-image: url(assets/images/pageHeader/header2.jpeg);">
        </div>
        <div class="site-footer__top">
            <div class="container">
                <div class="row">
                    <div class="col-xl-4 col-lg-4 col-md-4 wow fadeInUp" data-wow-delay="100ms">
                        <div class="footer-widget__column footer-widget__about">
                            <div class="footer-widget__about-logo elemento-padre">
                                <a href="#"><img src="assets/images/footer/IEH-footer-logo.png" class="elemento-hijo" alt=""></a>
                            </div>
                            <div class="footer-widget__about-text-box">
                                <p class="footer-widget__about-text">Soluciones energéticas e hídricas responsables con el medio ambiente.</p>
                            </div>
                            <!-- <div class="footer-widget__btn">
                                <a href="donate-now.html"> <span class="fa fa-heart"></span>Donate now</a>
                            </div> -->
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 wow fadeInUp" data-wow-delay="200ms">
                        <div class="footer-widget__column footer-widget__links clearfix">
                            <h3 class="footer-widget__title">Enlaces</h3>
                            <ul class="footer-widget__links-list list-unstyled clearfix">
                                <!-- <li><a href="#">Home</a></li> -->
                                <li><router-link to="/" style="color: #fff;">Inicio</router-link></li>
                                <li><router-link to="/about"  style="color: #fff;">Quienes Somos</router-link></li>
                                <!-- <li><router-link to="/service">Nuestros Servicios</router-link></li> -->
                                <li><router-link to="/electric" style="color: #fff;">IEH Electricidad</router-link></li>
                                <li><router-link to="/iehcontrol" style="color: #fff;">IEH Control</router-link></li>
                                <li><router-link to="/gallery" style="color: #fff;">Galería</router-link></li>
                                <li><router-link to="/contact" style="color: #fff;">Contacto</router-link></li>
                            </ul>
                        </div>
                    </div>

                    

                    <!-- <div class="col-xl-2 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                        <div class="footer-widget__column footer-widget__non-profit clearfix">
                            <h3 class="footer-widget__title">Non profit</h3>
                            <ul class="footer-widget__non-profit-list list-unstyled clearfix">
                                <li><a href="donation-details.html">Differently Abled Kids</a></li>
                                <li><a href="donation-details.html">Help Child Cancer</a></li>
                                <li><a href="donation-details.html">Clean Pure Water</a></li>
                                <li><a href="donation-details.html">Give them Education</a></li>
                                <li><a href="donation-details.html">Start a Fundraising</a></li>
                            </ul>
                        </div>
                    </div> -->
                    
                    <div class="col-xl-4 col-lg-4 col-md-4 wow fadeInUp" data-wow-delay="400ms">
                        <div class="footer-widget__column footer-widget__contact">
                            <h3 class="footer-widget__title">Contacto</h3>
                            <a href="https://goo.gl/maps/z338oRQ3dkw1DkYC7" target="_blank"><p class="footer-widget__contact-text" style="color: #fff;">Casablanca,<br>Chile
                            </p></a>
                            <ul class="list-unstyled footer-widget__contact-list">
                                <li>
                                    <div class="icon">
                                        <i class="fa fa-envelope"></i>
                                    </div>
                                    <div class="text">
                                        <p><a href="mailto:iehelectricidad@gmail.com" target="_blank">iehelectricidad@gmail.com</a></p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <i class="fas fa-phone-alt"></i>
                                    </div>
                                    <div class="text">
                                        <p><a href="tel:963933691">+56 9-6393-3691</a></p>
                                    </div>
                                </li>
                            </ul>
                            <div class="site-footer__social">
                                <!--a href="https://twitter.com/iehelectricidad" target="_blank"><i class="fab fa-twitter"></i></a-->
                                <a href="https://m.facebook.com/iehelectricidad/" target="_blank"><i class="fab fa-facebook"></i></a>
                                <!-- <a href="#"><i class="fab fa-pinterest-p"></i></a> -->
                                <a href="https://www.instagram.com/iehoficial/" target="_blank"><i class="fab fa-instagram"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="site-footer__bottom">
            <div class="container">
                <div class="row">
                    <div class="col-xl-12">
                        <div class="site-footer__bottom-inner">
                            <p class="site-footer__bottom-text">© Todos los Derechos Reservados 2022 Por <a href="#">iehcontrol.com</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!--Site Footer End-->

</template>
    <style>

        .site-footer__top {
            color:#fff !important;
        }

        .site-footer__bottom {
            background-color: #32a1d9 !important;
        }

        .site-footer__bottom-text {
            color:#fff !important;
        }

        .footer-widget__about-text {
            color:#fff !important;
        }


        @media only screen and (max-width: 1024px){
            .site-footer__social {
                padding-left: 72px ;
            }

            .footer-widget__contact-list {
                padding-left: 20px;
            }

        }    
        @media only screen and (max-width: 768px){
            .footer-widget__about-logo{
                padding-left: 65px;
            }

            .footer-widget__contact-list {
                padding-left: 4px;
            }

            .footer-widget__about-text {
                padding-left: 35px;
            }

            .site-footer__social {
                padding-left: 40px ;
            }

            .elemento-padre {
            display: flex;
            justify-content: center;
            align-items: center;
                }

            .elemento-hijo {
                display: flex;
                width: 140px;
                height:  auto;
            }
        }    

        @media only screen and (max-width: 414px) {
            .footer-widget__about-logo{
                padding-left: 70px;
            }
            .footer-widget__contact-list {
                padding-left: 70px;
            }

            .footer-widget__about-text {
                padding-left: 60px;
            }

            .site-footer__social {
                padding-left: 120px;
            }

            .elemento-padre {
            display: flex;
            justify-content: center;
            align-items: center;
                }

            .elemento-hijo {
                display: flex;
                width: 140px;
                height:  auto;
            }

        }

        @media only screen and (max-width: 390px){
            .footer-widget__about-logo {
                padding-left: 86px;
            }    
            .footer-widget__about-text {
                padding-left: 86px;
            }
            .site-footer__social {
                padding-left: 110px;
            }
        }

        @media only screen and (max-width: 375px){
            .footer-widget__about-logo{
                padding-left: 100px;
            }
            .footer-widget__about-text {
                padding-left: 82px;
            }
            .footer-widget__contact-list li {
                padding-left: 1px;
            }
            .site-footer__social {
                padding-left: 100px;
            }

            .elemento-padre {
            display: flex;
            justify-content: center;
            align-items: center;
                }

            .elemento-hijo {
                display: flex;
                width: 140px;
                height:  auto;
            }
        }

        @media only screen and (max-width: 320px){
            .footer-widget__about-logo{
                padding-left: 100px;
            }
            .footer-widget__about-text {
                padding-left: 85px;
            }
            .footer-widget__contact-list {
                padding-left: 40px;
            }
            .site-footer__social {
                padding-left: 72px;
            }

            .elemento-padre {
            display: flex;
            justify-content: center;
            align-items: center;
                }

            .elemento-hijo {
                display: flex;
                width: 140px;
                height:  auto;
            }
        }

        
        
        
    </style>
<script>
</script>